import merge from 'lodash/merge'
import D2C_Entity from './Entity'
import api from '@/api'
import objects from '@/objects'
import store from '@/store'

class D2C_Member extends D2C_Entity {
  target = 'member'
  icon = 'users'
  static objectType = 'entityType'
  static typeName = 'member'
  static fields = {
    account: {
      default: '',
      label: 'Account',
      path: 'account',
      required: false,
      readonly: true,
      omit: true,
      validate() {
        return null
      },
      creating: {},
    },
    actions: {
      default: {},
      label: 'Actions',
      path: 'actions',
      required: false,
      validate() {
        return null
      },
      updating: {},
      updatingAccess: {},
    },
    email: {
      autoselect: true,
      default: '',
      label: 'Email',
      path: 'email',
      required: true,
      validate() {
        return null
      },
      creating: {},
      updating: {
        autoselect: false,
        omit: true,
        readonly: true,
        required: false,
      },
    },
    expiration: {
      default: '',
      label: 'Access until',
      path: 'expiration',
      placeholder: 'Select...',
      required: false,
      validate() {
        return null
      },
      creating: {},
      updating: {},
    },
    name: {
      default: '',
      label: 'Name',
      path: 'name',
      required: true,
      validate(value) {
        if (value.length > 50) {
          return 'Invalid name'
        }
        return (value && value.length > 0) ? null : 'Must be set'
      },
      creating: {},
      updating: {
        required: false,
      },
    },
    role: {
      default: '',
      label: 'Role',
      path: 'role',
      required: false,
      validate() {
        return null
      },
      creating: {},
      updating: {},
    },
  }
  static create(props) {
    return new D2C_Member(props)
  }
  get _actions() {
    const rules = {}
    const actions = ['accManagement', 'hostCreate', 'hostDestroy', 'hostInfo', 'hostTerminal', 'hostUpdate', 'hostUsage', 'keyCreate', 'keyDestroy', 'projectCreate', 'projectDestroy', 'projectExport', 'projectInfo', 'projectUpdate', 'projectUsage', 'providerCreate', 'providerDestroy', 'providerUpdate', 'serviceChangeProject', 'serviceDestroy', 'serviceInfo', 'serviceMoveContainer', 'serviceScale', 'serviceTerminal', 'serviceUpdate', 'tariffManagement']
    for (const action of actions) {
      rules[action] = this.isOwner ? 1 : merge(
        {result: this._role.actions[action]},
        {result: this.actions[action]},
      ).result
    }
    return rules
  }
  get _doesExist() {
    return Boolean(this.id)
  }
  get _isExpired() {
    return this.expiration ? Date.now() - new Date(this.expiration).getTime() > 0 : false
  }
  get _role() {
    return store.getters.rolesById[this.role] || objects.Role.create(this.isOwner ? {name: 'Owner', actions: {}} : {name: 'Empty', actions: {}})
  }
  create() {
    return api.createMember(this.getValues('creating'))
  }
  update(changes) {
    return api.updateMember(this.id, changes || this.getChanges())
  }
  delete() {
    return api.deleteMember(this.id)
  }
}

export default D2C_Member
